<template>
    <div class="tw-flex tw-gap-2 brands">
        <a
            :class="`${getVariantStyles()} ${props.class} tw-cursor-pointer`"
            v-for="(network, i) in networksComputed"
            :key="i"
            @click="openNetwork(network.url)"
            v-show="network.url && network.url !== ''"
        >
            <q-icon
                :name="network.icon"
                :size="size ?? '16px'"
                class="!tw-text-primary hover:!tw-text-white"
            />
        </a>
    </div>
</template>

<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    variant?: string
    class?: string
    size?: string
    networks?: { url: string; icon: string }[]
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const defaultSettingsStore = useDefaultSettingsStore()
const { settings } = storeToRefs(defaultSettingsStore)

const networksComputed = computed(() => {
    if (props.networks) {
        return props.networks
    }
    return settings.value?.contacts?.networks
})

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

function getVariantStyles() {
    if (props.variant === "primary") {
        return "red"
    }

    // default styles
    return "tw-p-2 tw-bg-white tw-rounded-full tw-w-9 tw-h-9 tw-flex tw-place-items-center tw-place-content-center"
}

function openNetwork(url: string) {
    window.open(url)
}
</script>
